import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotHomeComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotHome',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M18 6.765v-2.41a1 1 0 0 0-2 0v2.41a1 1 0 0 0 2 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A26AFF",
    d: "m21.436 9.565-8.903-7.34a.957.957 0 0 0-1.232 0l-8.835 7.32-.136.12c-.67.61-.252 1.75.641 1.75H4v9.6a1 1 0 0 0 1 1h14.001a1 1 0 0 0 1-1v-9.54h1.046c.923-.02 1.3-1.202.562-1.772l-.173-.138Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M15 15.008a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6.997h6v-6.997Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M12 11.008a2.495 2.495 0 1 0 0-4.99 2.495 2.495 0 0 0 0 4.99Z"
  }));
};
SpotHomeComponent.displayName = 'SpotHome';
export var SpotHome = withProvisionalOverrideFromContext(SpotHomeComponent);
//# sourceMappingURL=index.js.map